module.exports = __webpack_public_path__ + "img/bookmark_selected.77213de7.svg";